import { dataLayerConfig } from '@aspendental/shared-components-web';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useAuthStore } from '@src/store/modules/auth.store';
import { useGTMStore } from '@src/store/modules/gtm.store';
import { getDeviceType } from '@src/utils/deviceType';

function fireVirtualPageView(): void {
	const { brand, websiteFacilityId, websiteFacilityName } = useGTMStore.getState();
	const { ssId } = useAuthStore.getState();

	dataLayerConfig({
		event: 'virtual_page_view',
		virtual_page_url: window.location.href,
		virtual_page_title: document.title,
		brand: brand || '',
		platform: 'nextjs',
		tag_session_id: ssId || '',
		...(websiteFacilityId && { website_selected_facility_id: websiteFacilityId }),
		...(websiteFacilityName && { website_selected_facility_name: websiteFacilityName }),
		device_type: getDeviceType(),
	});
}

export function useVirtualPageView(): void {
	const router = useRouter();

	useEffect(() => {
		fireVirtualPageView(); // initial load
		router.events.on('routeChangeComplete', fireVirtualPageView);
		return () => {
			router.events.off('routeChangeComplete', fireVirtualPageView);
		};
	}, [router.events]);
}
